// extracted by mini-css-extract-plugin
export var dropOver = "_ij-2";
export var dropValid = "_ij-1";
export var hidden = "_ij-3";
export var line = "_ij-0";